import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectTickets,
  headersTickets,
  valoresExibidosOffCanvasTickets,
} from './auxiliarTickets';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloDaf } from '../../../../services/enum/useModuloDaf';
import { useStatusTicket } from '../../../../services/enum/useStatusTicket';
import { useTipoTicket } from '../../../../services/enum/useTipoTicket';
import { getAllTickets } from '../../../../services/gestaoSisAF/ticketsService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import { getSubAbas } from '../subabas';

const MaisOpcoesTickets: React.FC = () => {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_Tickets;

  const navigate = useNavigate();
  const statusTicket = useStatusTicket();
  const moduloSisaf = useModuloDaf();
  const tipoTicket = useTipoTicket();

  const responsavelRetorno = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: 'Ângelo Morais' },
    { value: 2, label: 'Allan Ribeiro' },
    { value: 3, label: 'Jackson Ramos' },
    { value: 4, label: 'Mateus Farias' },
    { value: 99, label: 'Outro' },
  ];

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    moduloSisAf: 0,
    tipoTicket: 0,
    statusTicket: 0,
    mensagemUsuario: '',
    dataRetorno: '',
    retornoDevs: '',
    responsavelDev: '',
    observacoes: '',
    responsavelRetornoOption: 0,
  });

  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllTickets();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const tableData = data
    .filter((item: any) => {
      return (
        (formFiltros.statusTicket === 0 ||
          item.statusTicket === Number(formFiltros.statusTicket)) &&
        (formFiltros.moduloSisAf === 0 ||
          item.moduloSisAf === Number(formFiltros.moduloSisAf)) &&
        (Number(formFiltros.tipoTicket) === 0 ||
          item.tipoTicket === Number(formFiltros.tipoTicket)) &&
        (formFiltros.mensagemUsuario === '' ||
          item.mensagemUsuario
            .toLowerCase()
            .includes(formFiltros.mensagemUsuario.toLowerCase())) &&
        (formFiltros.responsavelDev === '' ||
          item.responsavelDev ===
            responsavelRetorno[Number(formFiltros.responsavelDev)].label)
      );
    })
    .map((item) => {
      // Definindo cores de fundo e texto com base no status do ticket
      let statusBackgroundColor = '';
      let statusTextColor = '';

      const statusLabel = statusTicket[item.statusTicket].label;

      if (statusLabel === 'Não respondido') {
        statusBackgroundColor = 'red';
        statusTextColor = 'white';
      } else if (statusLabel === 'Em análise') {
        statusBackgroundColor = 'yellow';
        statusTextColor = 'black';
      } else if (statusLabel === 'Respondido') {
        statusBackgroundColor = 'lightgreen';
        statusTextColor = 'black';
      }

      return {
        id: item.id,
        statusTicket: (
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: statusTextColor,
              borderRadius: '5px',
              padding: '10px',
              display: 'inline-block',
              minWidth: '50px',
              textAlign: 'center',
            }}
          >
            {statusLabel}
          </span>
        ),
        moduloSisAf: moduloSisaf[item.moduloSisAf].label,
        tipoTicket: tipoTicket[item.tipoTicket].label,
        dataRegistro: formatDateSimp(item.dataRegistro),
        responsavel: item.usuarioRegistro.nomeCompleto,
        responsavelDev: item.responsavelDev
          ? item.responsavelDev
          : 'Não definido',
        mensagemUsuario:
          item.mensagemUsuario.length > 110
            ? item.mensagemUsuario.slice(0, 110) + '...'
            : item.mensagemUsuario,
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => {
    // Definindo cores de fundo e texto com base no status do ticket
    let statusBackgroundColor = '';
    let statusTextColor = '';

    const statusLabel = statusTicket[item.statusTicket].label;

    if (statusLabel === 'Não respondido') {
      statusBackgroundColor = 'red';
      statusTextColor = 'white';
    } else if (statusLabel === 'Em análise') {
      statusBackgroundColor = 'yellow';
      statusTextColor = 'black';
    } else if (statusLabel === 'Respondido') {
      statusBackgroundColor = 'lightgreen';
      statusTextColor = 'black';
    }

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusTicket: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '-10px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: statusTextColor,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusLabel}
          </span>
        </div>
      ),
      interfaceSisAf: 'DAF',
      versaoSisaf: item.versaoSisaf,
      moduloSisAf: moduloSisaf[item.moduloSisAf].label,
      tipoTicket: tipoTicket[item.tipoTicket].label,
      responsavel: item.usuarioRegistro.nomeCompleto,
      dataEnvio: formatDateSimp(item.dataRegistro),
      dataInicio: formatDateSimp(item.dataInicio),
      dataRetorno: formatDateSimp(item.dataRetorno),
      mensagemUsuario: item.mensagemUsuario,
      responsavelDev: item.responsavelDev ? item.responsavelDev : '-',
      retornoDevs: item.retornoDevs ? item.retornoDevs : '-',
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'level' || name === 'statusDesenvolvimento') {
      // Permitir somente números, '<', '>', ou uma combinação destes com números
      if (
        /^[0-9]*$/.test(value) ||
        value === '<' ||
        value === '>' ||
        /^[<>][0-9]+$/.test(value)
      ) {
        setFormFiltros((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === 'interfaceSisAf' || name === 'moduloSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      moduloSisAf: 0,
      tipoTicket: 0,
      statusTicket: 0,
      mensagemUsuario: '',
      dataRetorno: '',
      retornoDevs: '',
      responsavelDev: '',
      observacoes: '',
      responsavelRetornoOption: 0,
    });
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    interfaceSisAf: number;
    versaoSisaf: string;
    moduloSisAf: number;
    tipoTicket: number;
    statusTicket: number;
    mensagemUsuario: string;
    dataEnvio: string;
    dataInicio: string;
    dataRetorno: string;
    retornoDevs: string;
    responsavelDev: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        statusTicket: statusTicket[item.statusTicket]?.label || '-',
        interfaceSisAf: 'DAF',
        versaoSisaf: item.versaoSisaf,
        moduloSisAf: moduloSisaf[item.moduloSisAf]?.label || '-',
        tipoTicket: tipoTicket[item.tipoTicket]?.label || '-',
        responsavel: item.usuarioRegistro.nomeCompleto,
        dataEnvio: item.dataRegistro,
        dataInicio: item.dataInicio,
        dataRetorno: item.dataRetorno,
        mensagemUsuario: item.mensagemUsuario,
        retornoDevs: item.retornoDevs,
        responsavelDev: item.responsavelDev,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const filteredDataForExport = data.filter((item) => {
    return (
      (formFiltros.statusTicket === 0 ||
        item.statusTicket === Number(formFiltros.statusTicket)) &&
      (formFiltros.moduloSisAf === 0 ||
        item.moduloSisAf === Number(formFiltros.moduloSisAf)) &&
      (Number(formFiltros.tipoTicket) === 0 ||
        item.tipoTicket === Number(formFiltros.tipoTicket)) &&
      (formFiltros.mensagemUsuario === '' ||
        item.mensagemUsuario
          .toLowerCase()
          .includes(formFiltros.mensagemUsuario.toLowerCase()))
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="250px">
              <SelectInput
                name="statusTicket"
                options={statusTicket}
                label="Status"
                value={formFiltros.statusTicket}
                onChange={handleChange}
              />
            </CustomCol>

            <CustomCol width="250px">
              <SelectInput
                name="moduloSisAf"
                options={moduloSisaf}
                label="Módulo SisAF"
                value={formFiltros.moduloSisAf}
                onChange={handleChange}
              />
            </CustomCol>

            <CustomCol width="250px">
              <SelectInput
                name="tipoTicket"
                options={tipoTicket}
                label="Tipo"
                value={formFiltros.tipoTicket}
                onChange={handleChange}
              />
            </CustomCol>

            <CustomCol width="250px">
              <SelectInput
                name="responsavelDev"
                options={responsavelRetorno}
                label="Responsável Dev"
                value={formFiltros.responsavelDev}
                onChange={handleChange}
              />
            </CustomCol>

            <CustomCol>
              <Input
                name="mensagemUsuario"
                label="Mensagem"
                value={formFiltros.mensagemUsuario}
                id="mensagemUsuario"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>
        <Tabela
          headers={headersTickets}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasTickets}
          tituloCanvas="TICKET DO SISAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport),
              valoresExibidosOffCanvasTickets,
              fieldObjectTickets,
              'sisaf_tickets.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MaisOpcoesTickets;
